import { ReactComponent as ErrorOutlined } from '../../../../assets/icons/error-outlined.svg';

export { ErrorOutlined };
